import React from 'react';
import { FormattedMessage } from 'react-intl';

const TaxHouseholdCompositionSummary = props => {

    const {
        analyzeFamily,
        family,
        householdMembers
    } = props;

    const pairsInfo = family.pairs.filter(pair => pair.isPairAccordingToLaw).map(pair => {

        const {
            pairId,
            spouse1: {
                spouse1fullName
            },
            spouse2: {
                spouse2fullName
            },
            liveTogether
        } = pair;

        return (
            <p key={pairId}>
                <FormattedMessage
                    id='ssap.family_household.tax_composition.spouses_info'
                    values={{
                        spouse1fullName: <strong>{ spouse1fullName }</strong>,
                        spouse2fullName: <strong>{ spouse2fullName }</strong>,
                        liveTogether: liveTogether ? 
                            <FormattedMessage id='ssap.family_household.tax_composition.live'/> : 
                            <FormattedMessage id='ssap.family_household.tax_composition.do_not_live'/>
                    }}
                />
            </p>
        );
    });

    const singles = family.dependents.filter(d => !d.spouse).map(d => {
        const {
            addressId,
            dependentFullName,
            dependentPersonId,
            parents,
            siblings
        } = d;

        const parentsQtyLivesWith = (() => {
            if(!parents) {
                return 0;
            }
            return parents.filter(parent => analyzeFamily.getHhmByPersonId(parent, householdMembers).addressId === addressId).length;
        })();

        const siblingsQtyLivesWith = (() => {
            if(!siblings) {
                return 0;
            }
            return siblings.filter(sibling => analyzeFamily.getHhmByPersonId(sibling, householdMembers).addressId === addressId).length;
        })();

        const getParentsInfo = () => {
            return !parents ?
                <FormattedMessage id='ssap.family_household.tax_composition.has_no_parents'/> :
                parentsQtyLivesWith === 0 ?
                    <FormattedMessage id='ssap.family_household.tax_composition.does_not_live_with_parents'/> :
                    parentsQtyLivesWith === 1 ?
                        <FormattedMessage id='ssap.family_household.tax_composition.lives_with_one_parent'/> :
                        <FormattedMessage id='ssap.family_household.tax_composition.lives_with_both_parents'/>;
        };

        const getSiblingsInfo = () => {
            return !siblings ?
                <FormattedMessage id='ssap.family_household.tax_composition.has_no_siblings'/> :
                siblingsQtyLivesWith === 0 ?
                    <FormattedMessage id='ssap.family_household.tax_composition.does_not_live_with_siblings'/> :
                    <FormattedMessage
                        id='ssap.family_household.tax_composition.lives_with_siblings'
                        values={{
                            siblingsQtyLivesWith
                        }}
                    />;
        };

        return (
            <p key={`${dependentFullName}_${dependentPersonId}`}>
                <FormattedMessage
                    id='ssap.family_household.tax_composition.dependent_info'
                    values={{
                        dependentFullName: <strong>{ dependentFullName }</strong>,
                        parentsInfo: getParentsInfo(),
                        siblingsInfo: getSiblingsInfo(),
                        showAdditionalText: !siblings
                    }}
                />
            </p>
        );

    });

    const disclaimer =
        <p key={'disclaimer'}>
            <FormattedMessage id='ssap.family_household.tax_composition.disclaimer'/>
        </p>;

    return [
        ...pairsInfo,
        ...singles,
        disclaimer
    ];
};

export default TaxHouseholdCompositionSummary;